import { render, staticRenderFns } from "./TableJudgesEditComponent.vue?vue&type=template&id=6ad517c1"
import script from "./TableJudgesEditComponent.vue?vue&type=script&lang=js"
export * from "./TableJudgesEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports